export default {
    book: 'Book {product}',
    age_limit: 'Kun over {age}',
    upgrade_product: 'Opgradér produkt',
    choose_product: 'Vælg {product}',
    days: '{count} dag | {count} dage',
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Fuld forsikring',
            zero_excess: 'Nul overskydende',
            phone_as_a_key: 'Telefon som nøgle',
            straight_to_car: 'Ingen ventetid',
            no_queues: 'Ingen køer',
            online_id_check: 'Online ID-kontrol',
            self_checkout: 'Selvudtjekning',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/da/quotes/vehicle_card.js